import { IAppState } from '../../redux';
import { IPublishOption } from '../../redux/reducers';
import { selectActiveService } from './selectActiveService';

export function selectActivePeriod(state: IAppState): IPublishOption | null {
  const selectedService = selectActiveService(state);

  if (!selectedService) {
    return null;
  }

  const {
    publishOptions: { periods, selectedPeriodId },
  } = selectedService;

  if (!selectedPeriodId) {
    return null;
  }

  return periods[selectedPeriodId];
}
